<template>
  <div class="last-update">
    <div class="last-update__head">
      <div>
        <div class="last-update__title">
          Последние обновления
        </div>
        <div class="last-update__subtitle">
          Показываем два свежих релиза. Полная история доступна по клику.
        </div>
      </div>

      <button
        type="button"
        class="last-update__all"
        @click="openUpdatesModal"
      >
        Все
        <feather-icon
          icon="ArrowRightIcon"
          size="15"
        />
      </button>
    </div>

    <div class="last-update__list">
      <div
        v-for="(update, index) in latestUpdates"
        :key="index"
        class="update-card"
        role="button"
        tabindex="0"
        @click="openUpdatesModal"
        @keydown.enter.prevent="openUpdatesModal"
      >
        <div class="update-card__date">
          {{ update.title }}
        </div>

        <ul class="update-card__list">
          <li
            v-for="(item, key) in update.list"
            :key="key"
          >
            {{ item }}
          </li>
        </ul>
      </div>
    </div>

    <div
      v-if="isUpdatesModalVisible"
      class="updates-modal"
      @click.self="closeUpdatesModal"
    >
      <div
        class="updates-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="updates-modal-title"
      >
        <div class="updates-modal__head">
          <div>
            <div
              id="updates-modal-title"
              class="updates-modal__title"
            >
              История обновлений Eddy24
            </div>
            <div class="updates-modal__subtitle">
              Все релизы и улучшения за 2026 год.
            </div>
          </div>

          <button
            type="button"
            class="updates-modal__close"
            aria-label="Закрыть историю обновлений"
            @click="closeUpdatesModal"
          >
            <feather-icon
              icon="XIcon"
              size="18"
            />
          </button>
        </div>

        <div class="updates-modal__list">
          <div
            v-for="(update, index) in updates"
            :key="index"
            class="updates-modal__item"
          >
            <div class="updates-modal__date">
              {{ update.title }}
            </div>
            <ul>
              <li
                v-for="(item, key) in update.list"
                :key="key"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LastUpdate',
  data() {
    return {
      isUpdatesModalVisible: false,
      updates: [
        {
          title: '6 мая 2026',
          list: [
            'Обновлена главная страница: быстрые действия, фокус на сегодня и компактные показатели по контенту',
            'Блок с первыми шагами теперь можно скрыть, чтобы он не отвлекал после настройки пространства',
            'История обновлений открывается в модальном окне и не перегружает главный экран',
          ],
        },
        {
          title: '24 апреля 2026',
          list: [
            'Улучшена навигация между курсами, тестами и материалами',
            'Добавлены более понятные состояния пустых списков для новых рабочих пространств',
            'Исправлены мелкие ошибки при сохранении материалов с файлами и ссылками',
          ],
        },
        {
          title: '8 апреля 2026',
          list: [
            'В статистике появились быстрые переходы к сотрудникам с незавершенным обучением',
            'Карточки курсов стали компактнее и лучше читаются на небольших экранах',
            'Оптимизирована загрузка списков тестов и материалов',
          ],
        },
        {
          title: '19 марта 2026',
          list: [
            'В базе знаний улучшена структура разделов и вложенных материалов',
            'Добавлены подсказки при создании курса из нескольких типов контента',
            'Исправлено отображение длинных названий материалов в списках',
          ],
        },
        {
          title: '27 февраля 2026',
          list: [
            'Обновлен раздел сотрудников: история прохождения стала нагляднее',
            'Добавлена отправка повторного письма с доступом из карточки сотрудника',
            'Исправлены ошибки в отображении прогресса по завершенным тестам',
          ],
        },
        {
          title: '16 января 2026',
          list: [
            'Обновлен редактор материалов: стало проще добавлять изображения, файлы и видео',
            'В тестах улучшена работа с вариантами ответов и сохранением вопросов',
            'Повышена стабильность личного кабинета сотрудника на мобильных устройствах',
          ],
        },
      ],
    }
  },
  computed: {
    latestUpdates() {
      return this.updates.slice(0, 2)
    },
  },
  mounted() {
    window.addEventListener('keydown', this.handleEscape)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleEscape)
  },
  methods: {
    openUpdatesModal() {
      this.isUpdatesModalVisible = true
    },
    closeUpdatesModal() {
      this.isUpdatesModalVisible = false
    },
    handleEscape(event) {
      if (event.key === 'Escape') {
        this.closeUpdatesModal()
      }
    },
  },
}
</script>

<style lang="scss">
.last-update {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #eef1f4;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 12px 26px rgba(17, 24, 39, 0.05);

  &__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 18px;
    margin-bottom: 20px;
  }

  &__title {
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    color: #111827;
  }

  &__subtitle {
    margin-top: 6px;
    font-size: 14px;
    line-height: 20px;
    color: #6b7280;
  }

  &__all {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 36px;
    padding: 0 12px;
    border: none;
    border-radius: 8px;
    color: #0088cc;
    background: rgba(0, 136, 204, 0.1);
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    cursor: pointer;
    transition: background .2s, transform .2s;

    &:hover {
      transform: translateY(-1px);
      background: rgba(0, 136, 204, 0.16);
    }
  }

  &__list {
    display: grid;
    gap: 12px;
    flex: 1;
  }

  .update-card {
    padding: 18px;
    border-radius: 8px;
    border: 1px solid #eef1f4;
    background: #f9fafb;
    cursor: pointer;
    transition: transform .2s, background .2s, border-color .2s;

    &:hover {
      transform: translateY(-2px);
      background: #ffffff;
      border-color: rgba(0, 136, 204, 0.25);
    }

    &__date {
      display: inline-flex;
      align-items: center;
      min-height: 28px;
      padding: 0 10px;
      margin-bottom: 14px;
      border-radius: 8px;
      color: #0088cc;
      background: rgba(0, 136, 204, 0.1);
      font-size: 13px;
      line-height: 18px;
      font-weight: 600;
    }

    &__list {
      padding-left: 18px;
      margin: 0;
      color: #4b5563;
      font-size: 14px;
      line-height: 20px;

      li {
        padding-bottom: 9px;

        &:last-child {
          padding-bottom: 0;
        }
      }
    }
  }
}

.updates-modal {
  position: fixed;
  inset: 0;
  z-index: 1055;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
  background: rgba(17, 24, 39, 0.44);

  &__dialog {
    width: min(760px, 100%);
    max-height: min(760px, calc(100vh - 56px));
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 28px 70px rgba(17, 24, 39, 0.24);
  }

  &__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    padding: 24px 24px 18px;
    border-bottom: 1px solid #eef1f4;
  }

  &__title {
    font-size: 22px;
    line-height: 30px;
    font-weight: 600;
    color: #111827;
  }

  &__subtitle {
    margin-top: 6px;
    font-size: 14px;
    line-height: 20px;
    color: #6b7280;
  }

  &__close {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: none;
    border-radius: 8px;
    color: #6b7280;
    background: #f3f4f6;
    cursor: pointer;
    transition: background .2s, color .2s;

    &:hover {
      color: #111827;
      background: #e5e7eb;
    }
  }

  &__list {
    display: grid;
    gap: 14px;
    overflow-y: auto;
    padding: 18px 24px 24px;
  }

  &__item {
    padding: 18px;
    border-radius: 8px;
    border: 1px solid #eef1f4;
    background: #f9fafb;
  }

  .updates-modal__date {
    display: inline-flex;
    min-height: 28px;
    align-items: center;
    padding: 0 10px;
    margin-bottom: 12px;
    border-radius: 8px;
    color: #0088cc;
    background: rgba(0, 136, 204, 0.1);
    font-size: 13px;
    line-height: 18px;
    font-weight: 600;
  }

  ul {
    margin: 0;
    padding-left: 18px;
    color: #4b5563;
    font-size: 14px;
    line-height: 20px;

    li {
      padding-bottom: 9px;

      &:last-child {
        padding-bottom: 0;
      }
    }
  }
}

@media (max-width: 575px) {
  .updates-modal {
    align-items: stretch;
    padding: 14px;

    &__dialog {
      max-height: calc(100vh - 28px);
    }

    &__head,
    &__list {
      padding-left: 18px;
      padding-right: 18px;
    }
  }
}
</style>
